{
  "+ Add Exception": "+ Add Exception",
  "+ Operatory": "+ Operatory",
  "+ Provider": "+ Provider",
  "+ Service": "+ Service",
  "1 Appointment Type": "1 Appointment Type",
  "<0><0>Contact support</0> to upgrade these locations and enable Online Scheduling</0>": "<0><0>Contact support</0> to upgrade these locations and enable Online Scheduling</0>",
  "AI can see": "AI can see",
  "Access for Weave Support only": "Access for Weave Support only",
  "Add": "Add",
  "Add Availability": "Add Availability",
  "Add Availability for {{operatoryName}}": "Add Availability for {{operatoryName}}",
  "Add Exception": "Add Exception",
  "Add Link": "Add Link",
  "Add Provider": "Add Provider",
  "Add Rule Exception": "Add Rule Exception",
  "Add an appointment booking link to your website or social media pages. Find detailed instructions on setting up your booking link seamlessly across your digital platforms at": "Add an appointment booking link to your website or social media pages. Find detailed instructions on setting up your booking link seamlessly across your digital platforms at",
  "Add appointment booking directly to your Google Business Profile, enhancing accessibility and streamlining engagement. Connect now for effortless customer interaction.": "Add appointment booking directly to your Google Business Profile, enhancing accessibility and streamlining engagement. Connect now for effortless customer interaction.",
  "Add to Google Business Profile": "Add to Google Business Profile",
  "Advance Booking Requirements": "Advance Booking Requirements",
  "Advance booking duration updated successfully": "Advance booking duration updated successfully",
  "After Hours": "After Hours",
  "After Hours Template": "After Hours Template",
  "All Day": "All Day",
  "All Exceptions": "All Exceptions",
  "All Occurrences": "All Occurrences",
  "All Resources": "All Resources",
  "All day": "All day",
  "All resources": "All resources",
  "All resources at this location": "All resources at this location",
  "All-Day": "All-Day",
  "Allow Self-Booking": "Allow Self-Booking",
  "Amount must be greater than 0": "Amount must be greater than 0",
  "An error occurred while loading your settings.": "An error occurred while loading your settings.",
  "Answer a few questions to get your scheduling ready for patients": "Answer a few questions to get your scheduling ready for patients",
  "Applied Filters ({{count}})_one": "Applied Filters ({{count}})",
  "Applied Filters ({{count}})_other": "Applied Filters ({{count}})",
  "Apply": "Apply",
  "Apply Exception To": "Apply Exception To",
  "Apply Filters": "Apply Filters",
  "Apply to All": "Apply to All",
  "Apply to Chosen": "Apply to Chosen",
  "Apply to Combination": "Apply to Combination",
  "Apply to all": "Apply to all",
  "Apply to chosen": "Apply to chosen",
  "Appointment Booking": "Appointment Booking",
  "Appointment Hours": "Appointment Hours",
  "Appointment Type": "Appointment Type",
  "Appointment Types": "Appointment Types",
  "Appointment hours": "Appointment hours",
  "Archive": "Archive",
  "Are you sure you want to delete this availability rule?": "Are you sure you want to delete this availability rule?",
  "Are you sure you want to delete this rule exception <strong>{{name}}</strong>?": "Are you sure you want to delete this rule exception <strong>{{name}}</strong>?",
  "Are you sure you want to delete this rule exception? This action cannot be undone.": "Are you sure you want to delete this rule exception? This action cannot be undone.",
  "Are you sure you want to delete {{exceptionName}}? Doing so will remove this exception from {{entityName}}'s schedule, and their availability will be updated accordingly.": "Are you sure you want to delete {{exceptionName}}? Doing so will remove this exception from {{entityName}}'s schedule, and their availability will be updated accordingly.",
  "Are you sure you want to delete {{serviceName}}?": "Are you sure you want to delete {{serviceName}}?",
  "Auto-Response Template": "Auto-Response Template",
  "Auto-Response Templates": "Auto-Response Templates",
  "Availability": "Availability",
  "Availability Rule created successfully": "Availability Rule created successfully",
  "Availability Rule updated successfully": "Availability Rule updated successfully",
  "Availability Rules": "Availability Rules",
  "Availability calculated by:": "Availability calculated by:",
  "Availability deleted successfully": "Availability deleted successfully",
  "Availability for": "Availability for",
  "Availability saved successfully": "Availability saved successfully",
  "Availability:": "Availability:",
  "Available": "Available",
  "Available start times: {{times}}": "Available start times: {{times}}",
  "Back": "Back",
  "Booking": "Booking",
  "Booking Cadence": "Booking Cadence",
  "Booking Links": "Booking Links",
  "Booking Rules": "Booking Rules",
  "Booking Site Setup": "Booking Site Setup",
  "Business Hours": "Business Hours",
  "Business Hours Template": "Business Hours Template",
  "Cadence preview:": "Cadence preview:",
  "Cancel": "Cancel",
  "Change Availability Mode": "Change Availability Mode",
  "Change Defaults": "Change Defaults",
  "Changing modes will:": "Changing modes will:",
  "Choose how you want to organize and calculate availability for scheduling. This setting determines how your schedules are structured.": "Choose how you want to organize and calculate availability for scheduling. This setting determines how your schedules are structured.",
  "Choose the Exception Target": "Choose the Exception Target",
  "Clean slate: No previous schedule exceptions recorded": "Clean slate: No previous schedule exceptions recorded",
  "Clear": "Clear",
  "Clear All": "Clear All",
  "Click or drag & drop these dynamic chips to add to your message": "Click or drag & drop these dynamic chips to add to your message",
  "Collect a pre-payment for this service type": "Collect a pre-payment for this service type",
  "Combination of resources at this location": "Combination of resources at this location",
  "Confirm Change": "Confirm Change",
  "Continue": "Continue",
  "Continuous": "Continuous",
  "Continuous booking (no set intervals) Start times fill gaps as previous appointments end.": "Continuous booking (no set intervals) Start times fill gaps as previous appointments end.",
  "Continuous booking (no set intervals) Start times fill gaps as previous appointments end: 8:30 AM, 9:15 AM, 10:00 AM...": "Continuous booking (no set intervals) Start times fill gaps as previous appointments end: 8:30 AM, 9:15 AM, 10:00 AM...",
  "Continuous booking with {{duration}} minute service duration": "Continuous booking with {{duration}} minute service duration",
  "Copy Snippet": "Copy Snippet",
  "Copy and paste the code snippet below into the <head> section of the webpage where you want the Text Connect widget to appear:": "Copy and paste the code snippet below into the <head> section of the webpage where you want the Text Connect widget to appear:",
  "Create Schedule": "Create Schedule",
  "Current": "Current",
  "Custom": "Custom",
  "Custom Fields": "Custom Fields",
  "Custom Fields in Online Scheduling gathers information for appointment approval decisions only. This data is not saved after the request is processed.": "Custom Fields in Online Scheduling gathers information for appointment approval decisions only. This data is not saved after the request is processed.",
  "Customers can view availability and schedule appointments at any of your office locations.": "Customers can view availability and schedule appointments at any of your office locations.",
  "Customers can view availability and schedule appointments specifically at one location.": "Customers can view availability and schedule appointments specifically at one location.",
  "Customers can view availability and schedule appointments with providers at your office.": "Customers can view availability and schedule appointments with providers at your office.",
  "Customize Your Message": "Customize Your Message",
  "Customize appointment types for your practice. Edit settings for online booking and internal use. Changes affect Weave systems but won't sync to your practice management software.": "Customize appointment types for your practice. Edit settings for online booking and internal use. Changes affect Weave systems but won't sync to your practice management software.",
  "Customize the content of the automatic messages your office sends out when appointment requests are received and confirmed.": "Customize the content of the automatic messages your office sends out when appointment requests are received and confirmed.",
  "Customize which information is gathered from users booking appointments through online scheduling.": "Customize which information is gathered from users booking appointments through online scheduling.",
  "Customize your message": "Customize your message",
  "Date": "Date",
  "Date cannot be in the past": "Date cannot be in the past",
  "Date/Days of Week": "Date/Days of Week",
  "Day(s)": "Day(s)",
  "Day(s) of the week": "Day(s) of the week",
  "Days": "Days",
  "Default Provider(s) - {{operatoryName}}": "Default Provider(s) - {{operatoryName}}",
  "Default Providers": "Default Providers",
  "Default providers are used for all working hours of this operatory unless you specify different providers for specific time blocks.": "Default providers are used for all working hours of this operatory unless you specify different providers for specific time blocks.",
  "Define what services you offer. Visit <1>Availability Rules</1> to control when, where and how they’re available.": "Define what services you offer. Visit <1>Availability Rules</1> to control when, where and how they’re available.",
  "Define what services you offer. Visit <2>Availability Rules</2> to control when, where and how they're available.": "Define what services you offer. Visit <2>Availability Rules</2> to control when, where and how they're available.",
  "Define when this operatory is open for appointments. Create weekly schedules for regular hours or add one-time blocks for special dates.": "Define when this operatory is open for appointments. Create weekly schedules for regular hours or add one-time blocks for special dates.",
  "Define when this provider is available for appointments. Create weekly schedules for regular hours or add one-time blocks for special dates.": "Define when this provider is available for appointments. Create weekly schedules for regular hours or add one-time blocks for special dates.",
  "Delete": "Delete",
  "Delete Availability Rule": "Delete Availability Rule",
  "Delete Availability Rule?": "Delete Availability Rule?",
  "Delete Exception": "Delete Exception",
  "Delete Rule Exception": "Delete Rule Exception",
  "Describe the service type for patients...": "Describe the service type for patients...",
  "Details": "Details",
  "Display Name": "Display Name",
  "Display Status": "Display Status",
  "Display names updated successfully": "Display names updated successfully",
  "Duplicate": "Duplicate",
  "Duplicate to Another Resource": "Duplicate to Another Resource",
  "Duration": "Duration",
  "Duration (Min)": "Duration (Min)",
  "Easily optimize your calendar-view, set precise appointment and provider hours, define appointment types, enable online scheduling, and effortlessly handle automated text message templates.": "Easily optimize your calendar-view, set precise appointment and provider hours, define appointment types, enable online scheduling, and effortlessly handle automated text message templates.",
  "Edit": "Edit",
  "Edit Availability for {{operatoryName}}": "Edit Availability for {{operatoryName}}",
  "Edit Exception": "Edit Exception",
  "Edit Rule Exception": "Edit Rule Exception",
  "Embed Widget": "Embed Widget",
  "End Date": "End Date",
  "End Time": "End Time",
  "End date must be after the start date": "End date must be after the start date",
  "End time is required": "End time is required",
  "End time must be after start time": "End time must be after start time",
  "End time must be after the start time": "End time must be after the start time",
  "Error fetching advance booking requirement setting. Please try again later.": "Error fetching advance booking requirement setting. Please try again later.",
  "Every": "Every",
  "Every 30 minutes": "Every 30 minutes",
  "Every hour": "Every hour",
  "Every {{interval}} {{timeUnit}} starting from {{startDate}}": "Every {{interval}} {{timeUnit}} starting from {{startDate}}",
  "Every {{interval}} {{unit}} starting {{startDate}}_one": "Every {{unit}} starting {{startDate}}",
  "Every {{interval}} {{unit}} starting {{startDate}}_other": "Every {{interval}} {{unit}} starting {{startDate}}",
  "Exception Date": "Exception Date",
  "Exception Name": "Exception Name",
  "Exception Target": "Exception Target",
  "Exception Time": "Exception Time",
  "Exception created successfully": "Exception created successfully",
  "Exception updated successfully": "Exception updated successfully",
  "Exceptions": "Exceptions",
  "Expired": "Expired",
  "Expired Exceptions": "Expired Exceptions",
  "Failed to create Availability Rule": "Failed to create Availability Rule",
  "Failed to create Provider schedule": "Failed to create Provider schedule",
  "Failed to create Rule Exception": "Failed to create Rule Exception",
  "Failed to create exception": "Failed to create exception",
  "Failed to create service type": "Failed to create service type",
  "Failed to create {{entityTypeName}} exception": "Failed to create {{entityTypeName}} exception",
  "Failed to delete Rule Exception": "Failed to delete Rule Exception",
  "Failed to delete availability": "Failed to delete availability",
  "Failed to delete rule exception": "Failed to delete rule exception",
  "Failed to delete schedule definition": "Failed to delete schedule definition",
  "Failed to delete service": "Failed to delete service",
  "Failed to delete {{entityTypeName}} exceptions": "Failed to delete {{entityTypeName}} exceptions",
  "Failed to publish settings": "Failed to publish settings",
  "Failed to save availability": "Failed to save availability",
  "Failed to save service": "Failed to save service",
  "Failed to update Availability Rule": "Failed to update Availability Rule",
  "Failed to update Provider schedule": "Failed to update Provider schedule",
  "Failed to update Rule Exception": "Failed to update Rule Exception",
  "Failed to update advance booking duration": "Failed to update advance booking duration",
  "Failed to update appointment type details": "Failed to update appointment type details",
  "Failed to update availability mode": "Failed to update availability mode",
  "Failed to update display names": "Failed to update display names",
  "Failed to update exception": "Failed to update exception",
  "Failed to update locations": "Failed to update locations",
  "Failed to update provider details": "Failed to update provider details",
  "Failed to update service type": "Failed to update service type",
  "Failed to update template": "Failed to update template",
  "Failed to update {{entityTypeName}} exception": "Failed to update {{entityTypeName}} exception",
  "Failed to update {{operatory}} details": "Failed to update {{operatory}} details",
  "Failed to {{status}} {{operatory}}": "Failed to {{status}} {{operatory}}",
  "Filter": "Filter",
  "Filters": "Filters",
  "First": "First",
  "First Name": "First Name",
  "Fourth": "Fourth",
  "Friday": "Friday",
  "General": "General",
  "Go to Schedule Settings": "Go to Schedule Settings",
  "Google Account": "Google Account",
  "Hello, this is {{practice_name}}. This text is to confirm that we've approved your appointment request for {{appt_datetime}}. See you then, {{preferred_name}}.": "Hello, this is {{practice_name}}. This text is to confirm that we've approved your appointment request for {{appt_datetime}}. See you then, {{preferred_name}}.",
  "Hello, this is {{practice_name}}. We have received your request for {{appt_datetime}}. We will message you once it has been reviewed.": "Hello, this is {{practice_name}}. We have received your request for {{appt_datetime}}. We will message you once it has been reviewed.",
  "Hidden": "Hidden",
  "Hidden from patient booking. For staff use only.": "Hidden from patient booking. For staff use only.",
  "Hours": "Hours",
  "Hygienist": "Hygienist",
  "Icon": "Icon",
  "Incomplete setup": "Incomplete setup",
  "Insert this unique URL to add a Text Connect link anywhere on your website, social media, Google Business page, or other online platforms": "Insert this unique URL to add a Text Connect link anywhere on your website, social media, Google Business page, or other online platforms",
  "Interval": "Interval",
  "It looks like you do not have the permission to view this page. No access found for the schedule request feature.": "It looks like you do not have the permission to view this page. No access found for the schedule request feature.",
  "Last": "Last",
  "Last synced just now": "Last synced just now",
  "Last synced {{dayText}} ago": "Last synced {{dayText}} ago",
  "Last synced {{dayText}} and {{hourText}} ago": "Last synced {{dayText}} and {{hourText}} ago",
  "Last synced {{dayText}} and {{minText}} ago": "Last synced {{dayText}} and {{minText}} ago",
  "Last synced {{dayText}}, {{hourText}} and {{minText}} ago": "Last synced {{dayText}}, {{hourText}} and {{minText}} ago",
  "Last synced {{hourText}} ago": "Last synced {{hourText}} ago",
  "Last synced {{hourText}} and {{minText}} ago": "Last synced {{hourText}} and {{minText}} ago",
  "Last synced {{timeText}} ago": "Last synced {{timeText}} ago",
  "Let's set up your first appointment type": "Let's set up your first appointment type",
  "Location": "Location",
  "Location Settings": "Location Settings",
  "Locations updated successfully": "Locations updated successfully",
  "Make it easy for patients to find and book appointments with you online. Find instructions on adding your unique booking link to your Google Business Profile and business website.": "Make it easy for patients to find and book appointments with you online. Find instructions on adding your unique booking link to your Google Business Profile and business website.",
  "Manage All": "Manage All",
  "Manage Providers": "Manage Providers",
  "Manage the types of appointments your location(s) offer. Manage the duration and description of each appointment type to streamline scheduling.": "Manage the types of appointments your location(s) offer. Manage the duration and description of each appointment type to streamline scheduling.",
  "Manage your resources, including providers, {{operatories}}, and services. From here, you can configure availability and set booking rules to keep your schedule organized.": "Manage your resources, including providers, {{operatories}}, and services. From here, you can configure availability and set booking rules to keep your schedule organized.",
  "Manage your {{operatories}} and chairs for optimal scheduling and operations.": "Manage your {{operatories}} and chairs for optimal scheduling and operations.",
  "Message Templates": "Message Templates",
  "Min": "Min",
  "Monday": "Monday",
  "Months": "Months",
  "More": "More",
  "Multi-location booking site URL": "Multi-location booking site URL",
  "Name": "Name",
  "Name of Exception": "Name of Exception",
  "Name of Exception*": "Name of Exception*",
  "Never": "Never",
  "New Appointment Type": "New Appointment Type",
  "New Exception": "New Exception",
  "New Service": "New Service",
  "Next Occurrence Start": "Next Occurrence Start",
  "Next Occurrences": "Next Occurrences",
  "Next Occurring": "Next Occurring",
  "No": "No",
  "No Availability Configured": "No Availability Configured",
  "No appointment types match your search": "No appointment types match your search",
  "No availability templates found": "No availability templates found",
  "No available start times in this range for the selected service duration.": "No available start times in this range for the selected service duration.",
  "No display name changes to save": "No display name changes to save",
  "No filters applied": "No filters applied",
  "No location changes to save": "No location changes to save",
  "No matches found": "No matches found",
  "No operatories found": "No operatories found",
  "No providers found": "No providers found",
  "No results found": "No results found",
  "No services match your search": "No services match your search",
  "No {{operatories}} Found": "No {{operatories}} Found",
  "No {{operatories}} found": "No {{operatories}} found",
  "None": "None",
  "Not affect existing booked appointments": "Not affect existing booked appointments",
  "Office": "Office",
  "On day": "On day",
  "On the": "On the",
  "Online Scheduling": "Online Scheduling",
  "Operatories": "Operatories",
  "Operatory": "Operatory",
  "Organize by Providers": "Organize by Providers",
  "Organize by Treatment Rooms": "Organize by Treatment Rooms",
  "Organize schedules by individual providers. Best for practices where each provider has their own dedicated room or flexible room usage.": "Organize schedules by individual providers. Best for practices where each provider has their own dedicated room or flexible room usage.",
  "Organize schedules by treatment rooms and {{operatories}}. Best for offices where rooms are shared by multiple providers": "Organize schedules by treatment rooms and {{operatories}}. Best for offices where rooms are shared by multiple providers",
  "Out of Office": "Out of Office",
  "Past": "Past",
  "Patient Booking": "Patient Booking",
  "Patients can schedule appointments for this slot through your online booking portal and the AI scheduling assistant": "Patients can schedule appointments for this slot through your online booking portal and the AI scheduling assistant",
  "Pattern preview:": "Pattern preview:",
  "Please fill in all required fields": "Please fill in all required fields",
  "Practice Name": "Practice Name",
  "Pre-Payment Amount ($)": "Pre-Payment Amount ($)",
  "Primary Provider": "Primary Provider",
  "Procedure Codes": "Procedure Codes",
  "Procedure Codes (Optional)": "Procedure Codes (Optional)",
  "Provider": "Provider",
  "Provider & Services": "Provider & Services",
  "Provider Settings": "Provider Settings",
  "Provider schedule created successfully": "Provider schedule created successfully",
  "Provider schedule updated successfully": "Provider schedule updated successfully",
  "Provider(s)": "Provider(s)",
  "Provider*": "Provider*",
  "Providers": "Providers",
  "Providers & Appointment Types": "Providers & Appointment Types",
  "Published successfully": "Published successfully",
  "Recurrence": "Recurrence",
  "Recurrence Schedule": "Recurrence Schedule",
  "Recurrence Type": "Recurrence Type",
  "Recurring": "Recurring",
  "Recurring Only": "Recurring Only",
  "Refetch": "Refetch",
  "Refresh": "Refresh",
  "Remove filter: {{label}}": "Remove filter: {{label}}",
  "Reorganize how availability is displayed and managed": "Reorganize how availability is displayed and managed",
  "Repeat On": "Repeat On",
  "Repeat Pattern": "Repeat Pattern",
  "Repeat This Availability": "Repeat This Availability",
  "Repeat This Exception": "Repeat This Exception",
  "Repeat every": "Repeat every",
  "Request Only": "Request Only",
  "Request Only (needs confirmation)": "Request Only (needs confirmation)",
  "Requests can be made via the booking portal and require staff approval.": "Requests can be made via the booking portal and require staff approval.",
  "Require you to review and update schedule definitions": "Require you to review and update schedule definitions",
  "Required. The doctor responsible for billing and insurance claims at this operatory": "Required. The doctor responsible for billing and insurance claims at this operatory",
  "Reset": "Reset",
  "Resources": "Resources",
  "Rule Exception created successfully": "Rule Exception created successfully",
  "Rule Exception deleted successfully": "Rule Exception deleted successfully",
  "Rule Exception updated successfully": "Rule Exception updated successfully",
  "Rule Exceptions": "Rule Exceptions",
  "Rule exception deleted successfully": "Rule exception deleted successfully",
  "Saturday": "Saturday",
  "Save": "Save",
  "Save Changes": "Save Changes",
  "Schedule": "Schedule",
  "Schedule Availability": "Schedule Availability",
  "Schedule Definition (Templates)": "Schedule Definition (Templates)",
  "Schedules are organized by individual providers": "Schedules are organized by individual providers",
  "Schedules are organized by treatment rooms and {{operatories}}": "Schedules are organized by treatment rooms and {{operatories}}",
  "Search": "Search",
  "Search Appointment Types": "Search Appointment Types",
  "Search Operatory": "Search Operatory",
  "Search operatories": "Search operatories",
  "Search operatories by name": "Search operatories by name",
  "Second": "Second",
  "Select Providers": "Select Providers",
  "Select Resource": "Select Resource",
  "Select a day of the week": "Select a day of the week",
  "Select a practice location to view and manage availability rules.": "Select a practice location to view and manage availability rules.",
  "Select a provider": "Select a provider",
  "Select a resource to apply these settings to. This will create a copy of the availability rule for the selected resource.": "Select a resource to apply these settings to. This will create a copy of the availability rule for the selected resource.",
  "Select an operatory": "Select an operatory",
  "Select operatories": "Select operatories",
  "Select operatory": "Select operatory",
  "Select provider": "Select provider",
  "Select providers": "Select providers",
  "Select service": "Select service",
  "Select service types": "Select service types",
  "Selected: {{selectedDaysOfWeek}}": "Selected: {{selectedDaysOfWeek}}",
  "Selected: {{selectedDays}}.": "Selected: {{selectedDays}}.",
  "Self Bookable": "Self Bookable",
  "Self-Bookable": "Self-Bookable",
  "Service": "Service",
  "Service Description": "Service Description",
  "Service Name": "Service Name",
  "Service Type": "Service Type",
  "Service Type for General Request": "Service Type for General Request",
  "Service Type for {{apptTypeName}}": "Service Type for {{apptTypeName}}",
  "Service deleted successfully": "Service deleted successfully",
  "Service saved successfully": "Service saved successfully",
  "Service type created successfully": "Service type created successfully",
  "Service type updated successfully": "Service type updated successfully",
  "Serviceable Provider": "Serviceable Provider",
  "Services": "Services",
  "Services*": "Services*",
  "Set the minimum amount of time required between when a patient books and their appointment time. This helps prevent last-minute bookings and gives you adequate preparation time.": "Set the minimum amount of time required between when a patient books and their appointment time. This helps prevent last-minute bookings and gives you adequate preparation time.",
  "Set the standard appointment hours for this location to help manage appointment availability when using Online Scheduling.": "Set the standard appointment hours for this location to help manage appointment availability when using Online Scheduling.",
  "Set up scheduling rules to control your location's availability.": "Set up scheduling rules to control your location's availability.",
  "Show On Calendar Toggle": "Show On Calendar Toggle",
  "Show on Calendar": "Show on Calendar",
  "Single": "Single",
  "Single Occurrences": "Single Occurrences",
  "Single-location booking site URLs": "Single-location booking site URLs",
  "Slots at the top of each hour (on the hour)": "Slots at the top of each hour (on the hour)",
  "Slots at the top of each hour (on the hour)<1></1>Available start times: 9:00 AM, 10:00 AM, 11:00 AM...": "Slots at the top of each hour (on the hour)<1></1>Available start times: 9:00 AM, 10:00 AM, 11:00 AM...",
  "Slots every 30 minutes from 8:30 AM - 11:30 AM<1></1>Available start times: 8:30 AM, 9:00 AM, 9:30 AM, 10:00 AM": "Slots every 30 minutes from 8:30 AM - 11:30 AM<1></1>Available start times: 8:30 AM, 9:00 AM, 9:30 AM, 10:00 AM",
  "Slots every 30 minutes from {{start}} - {{end}}": "Slots every 30 minutes from {{start}} - {{end}}",
  "Slots every hour from 8:30 AM - 11:30 AM<1></1>Available start times: 8:30 AM, 9:30 AM, 10:30 AM": "Slots every hour from 8:30 AM - 11:30 AM<1></1>Available start times: 8:30 AM, 9:30 AM, 10:30 AM",
  "Slots every hour from {{start}} - {{end}}": "Slots every hour from {{start}} - {{end}}",
  "Snippet copied": "Snippet copied",
  "Snippet will be copied to clipboard": "Snippet will be copied to clipboard",
  "Some locations don’t have Online Scheduling Enabled": "Some locations don’t have Online Scheduling Enabled",
  "Sort By": "Sort By",
  "Sort By: {{name}}": "Sort By: {{name}}",
  "Source": "Source",
  "Specific Date": "Specific Date",
  "Specific date": "Specific date",
  "Specific resources at this location": "Specific resources at this location",
  "Staff Only": "Staff Only",
  "Start Date": "Start Date",
  "Start Time": "Start Time",
  "Start time and end time are required": "Start time and end time are required",
  "Start time is required": "Start time is required",
  "Status": "Status",
  "Success, updated template": "Success, updated template",
  "Successfully updated appointment type details": "Successfully updated appointment type details",
  "Successfully updated provider details": "Successfully updated provider details",
  "Successfully updated template": "Successfully updated template",
  "Sunday": "Sunday",
  "System Name": "System Name",
  "Text Connect allows you to add a text messaging option for customers on your website or other online platforms. Need help setting up Text Connect? Visit our": "Text Connect allows you to add a text messaging option for customers on your website or other online platforms. Need help setting up Text Connect? Visit our",
  "Text Connect can automatically respond to incoming messages with customized templates. You can set up separate templates for business hours and after hours.": "Text Connect can automatically respond to incoming messages with customized templates. You can set up separate templates for business hours and after hours.",
  "The exception applies only when all selected criteria match.": "The exception applies only when all selected criteria match.",
  "The exception applies when at least one of the selected criteria match.": "The exception applies when at least one of the selected criteria match.",
  "The provider automatically assigned to appointments booked in this operatory": "The provider automatically assigned to appointments booked in this operatory",
  "The provider who will perform the service": "The provider who will perform the service",
  "The selected date and time are in the past.": "The selected date and time are in the past.",
  "The {{operatory}} name as it appears in your Practice Management System": "The {{operatory}} name as it appears in your Practice Management System",
  "These appointment exceptions will affect all availability, including provider schedules. Only provider exceptions will override the appointment exceptions set here.": "These appointment exceptions will affect all availability, including provider schedules. Only provider exceptions will override the appointment exceptions set here.",
  "Third": "Third",
  "This action cannot be undone.": "This action cannot be undone.",
  "This name will be visible on your Weave calendar.": "This name will be visible on your Weave calendar.",
  "This office is really sticking to their schedule - no exceptions added so far!": "This office is really sticking to their schedule - no exceptions added so far!",
  "This operatory is hygiene": "This operatory is hygiene",
  "This setting will be available once AI Receptionist onboarding is complete.": "This setting will be available once AI Receptionist onboarding is complete.",
  "This template will be sent in response to messages received during your normal operating hours.": "This template will be sent in response to messages received during your normal operating hours.",
  "This template will be sent in response to messages received outside of your normal operating hours.": "This template will be sent in response to messages received outside of your normal operating hours.",
  "This will add a small expandable widget to your webpage that customers can use to initiate a text conversation.": "This will add a small expandable widget to your webpage that customers can use to initiate a text conversation.",
  "This will affect existing schedules": "This will affect existing schedules",
  "This will remove this availability rule but won't affect existing appointments.": "This will remove this availability rule but won't affect existing appointments.",
  "This {{entityTypeName}} is really sticking to their schedule - no exceptions added so far!": "This {{entityTypeName}} is really sticking to their schedule - no exceptions added so far!",
  "Thursday": "Thursday",
  "Time": "Time",
  "Time Frame": "Time Frame",
  "Time Unit": "Time Unit",
  "Tip: For collecting and retaining important patient information (e.g., insurance information, medical history, etc.), please use ": "Tip: For collecting and retaining important patient information (e.g., insurance information, medical history, etc.), please use ",
  "To add availability, operatories must be mapped and added to your organization's locations.": "To add availability, operatories must be mapped and added to your organization's locations.",
  "To add availability, providers must be mapped and added to your organization's locations.": "To add availability, providers must be mapped and added to your organization's locations.",
  "To add availability, {{operatories}} must be mapped and added to your organization's locations.": "To add availability, {{operatories}} must be mapped and added to your organization's locations.",
  "To calculate availability, both the assigned provider and the operatory must be available within the availability rule.": "To calculate availability, both the assigned provider and the operatory must be available within the availability rule.",
  "Top of the hour": "Top of the hour",
  "Try adjusting your search terms": "Try adjusting your search terms",
  "Try reloading the page. If the problem persists, contact Weave Support.": "Try reloading the page. If the problem persists, contact Weave Support.",
  "Tuesday": "Tuesday",
  "Unarchive": "Unarchive",
  "Unassigned": "Unassigned",
  "Unavailable": "Unavailable",
  "Unknown": "Unknown",
  "Upcoming": "Upcoming",
  "Update availability settings": "Update availability settings",
  "Update biographical info, assign appointment types, and manage regular schedules to ensure availability for scheduling accuracy.": "Update biographical info, assign appointment types, and manage regular schedules to ensure availability for scheduling accuracy.",
  "Updates to this page do not affect provider availability or online scheduling.": "Updates to this page do not affect provider availability or online scheduling.",
  "View": "View",
  "Visible": "Visible",
  "Weave Digital Forms": "Weave Digital Forms",
  "Website": "Website",
  "Wednesday": "Wednesday",
  "Weekly": "Weekly",
  "Weeks": "Weeks",
  "When customers click this link, they will be directed to a web portal where they can send a text message directly to your office.": "When customers click this link, they will be directed to a web portal where they can send a text message directly to your office.",
  "Whole dollar amounts only": "Whole dollar amounts only",
  "Yes": "Yes",
  "Your integrated system of record": "Your integrated system of record",
  "Your location's URL": "Your location's URL",
  "Your location's snippet": "Your location's snippet",
  "appointment type search": "appointment type search",
  "every month": "every month",
  "every week": "every week",
  "every {{frequency}} days": "every {{frequency}} days",
  "every {{frequency}} months": "every {{frequency}} months",
  "every {{frequency}} weeks": "every {{frequency}} weeks",
  "everyday": "everyday",
  "for step-by-step instructions": "for step-by-step instructions",
  "help center": "help center",
  "mins": "mins",
  "more": "more",
  "of the month": "of the month",
  "on {{n}} {{day}}": "on {{n}} {{day}}",
  "on {{weekList}}": "on {{weekList}}",
  "operatories": "operatories",
  "optional": "optional",
  "selected": "selected",
  "starting on the {{day}}": "starting on the {{day}}",
  "to": "to",
  "{first_name}": "{first_name}",
  "{{count}} Appointment Types_one": "{{count}} Appointment Type",
  "{{count}} Appointment Types_other": "{{count}} Appointment Types",
  "{{count}} day_one": "{{count}} day",
  "{{count}} day_other": "{{count}} days",
  "{{count}} hour_one": "{{count}} hour",
  "{{count}} hour_other": "{{count}} hours",
  "{{count}} min_one": "{{count}} min",
  "{{count}} min_other": "{{count}} mins",
  "{{entityTypeName}} exception created successfully": "{{entityTypeName}} exception created successfully",
  "{{entityTypeName}} exception updated successfully": "{{entityTypeName}} exception updated successfully",
  "{{entityTypeName}} exceptions deleted successfully": "{{entityTypeName}} exceptions deleted successfully",
  "{{label}}": "{{label}}",
  "{{name}}, +{{count}} services_one": "{{name}}, +{{count}} service",
  "{{name}}, +{{count}} services_other": "{{name}}, +{{count}} services",
  "{{operatory}} Name": "{{operatory}} Name",
  "{{operatory}} Settings": "{{operatory}} Settings",
  "{{operatory}} details update successfully": "{{operatory}} details update successfully",
  "{{operatory}} details updated successfully": "{{operatory}} details updated successfully",
  "{{operatory}} {{status}} successfully": "{{operatory}} {{status}} successfully",
  "{{text}}": "{{text}}",
  "{{unassignedLabel}}": "{{unassignedLabel}}",
  "{{unit}}": "{{unit}}"
}
